import { connect } from "react-redux";

import AddOptionOrSelectFromRadio from "../../../shared_components/add_option_or_select_from_radio";
import {
  savedSearchSubmitCancel, savedSearchSubmitTrigger,
  savedSearchSubmitRadioButtonClicked, savedSearchSubmitTextChange, NEW_VALUE
} from "../actions/data_hub_search";

const mapStateToProps = (state) => {
  const s = state.savedSearches;

  const hidden = !s.searchIsBeingSaved;
  const selectedOptionValue = s.selectedOptionValue;
  const options = s.options;
  const newOption = s.newOption;
  const textValue = s.textValue;

  const loadingOptions = s.loadingOptions;
  const showSpinner = s.searchIsBeingSubmitted;

  const newOptionNeedsName = selectedOptionValue === NEW_VALUE && !textValue;

  const newValue = NEW_VALUE;
  const placeholder = "New saved search name";
  const title = "Save this search";
  const addText = s.downloading ? "Download" : "Save";

  return {
    hidden, selectedOptionValue, options,
    textValue, newOption, loadingOptions, showSpinner, newOptionNeedsName,
    newValue, placeholder, title, addText
  };
};

const mapDispatchToProps = dispatch => ({
  onAdd: () => { dispatch(savedSearchSubmitTrigger()); },
  onCancel: () => { dispatch(savedSearchSubmitCancel()); },
  radioSelect: (e) => {
    dispatch(savedSearchSubmitRadioButtonClicked(e.target.value));
  },
  textChange: (e) => {
    dispatch(savedSearchSubmitTextChange(e.target.value));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOptionOrSelectFromRadio);
